import React from 'react';
import { VideoWrapper, VideoFrame, VideoChildrenContainer } from './styles';

export const Video: React.FC<IVideo> = ({
  src,
  children,
  inView = false,
  hideWhenNotInView = true,
  height = '450px',
}) => {
  if (!inView && hideWhenNotInView) {
    return null;
  }

  return (
    <VideoWrapper className="pj-ui-carousel-video" style={{ height }}>
      <VideoFrame src={src} title={src} />
      <VideoChildrenContainer className="pj-ui-carousel-video--children">
        {children}
      </VideoChildrenContainer>
    </VideoWrapper>
  );
};

interface IVideo {
  src: string;
  inView?: boolean;
  hideWhenNotInView?: boolean;
  height?: string;
}
